/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateProjectActions, CreateProjectActionTypes, CreateProjectState } from './types';

const initialState: CreateProjectState = {
  isOpen: false,
  organizationId: undefined,
};

export function createProject(state = initialState, action: CreateProjectActionTypes): CreateProjectState {
  switch (action.type) {
    case CreateProjectActions.OPEN_CREATE_PROJECT_OVERLAY:
      return {
        ...state,
        isOpen: true,
        organizationId: action.payload.organizationId,
      };
    case CreateProjectActions.CLOSE_CREATE_PROJECT_OVERLAY:
      return {
        ...state,
        isOpen: false,
        organizationId: undefined,
      };
    default:
      return state;
  }
}
